import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import AeisExamCourseFeesHeader from '../components/StudyingAboard/AeisPrecourseFees/AeisExamCourseFeesHeader';
import AeisExamCourseFeesInfo from '../components/StudyingAboard/AeisPrecourseFees/AeisExamCourseFeesInfo';
import Share from '../components/Share';
import SideOverlap from './sideOverlap';

export default function AeisExamFeesInfo() {
    return (
        <>
            <Header />
            <AeisExamCourseFeesHeader />
            <AeisExamCourseFeesInfo />
            <Share />
            <Footer />
            <SideOverlap />
        </>
    )
}